export const normalizeName = name => {
  switch (name) {
    case 'TYPE_LOCAL_GAS':
      return 'item.overview.type';
    case 'SERIES_LOCAL_GAS':
      return 'item.overview.serie';
    case 'MATERIAL_LOCAL_GAS':
      return 'item.overview.material';
    case 'BRAND_LOCAL_GAS':
      return 'item.overview.brand';
    default:
      return name;
  }
};

type Attribute = {
  featureName: string;
  attributeIdentifier: string;
  value: string;
}[];

export const groupAttributes = attributes => {
  let acc = {
    single: [] as Attribute,
    array: [] as Attribute,
  };
  Object.values(
    attributes.map(item => {
      if ((item.value as string[]) instanceof Array) {
        acc.array.push({
          featureName: item.featureName,
          attributeIdentifier: item.attributeIdentifier,
          value: item.value.join(', '),
        });
        return acc;
      }

      acc.single.push({
        featureName: normalizeName(item.featureName),
        attributeIdentifier: item.attributeIdentifier,
        value: item.value.toString(),
      });
      return acc;
    }),
  );

  return acc;
};
